<div class="my-5">
    <sm-page-header
        [breadcrumb]="breadcrumb"
        title="meeting.title"
        ></sm-page-header>
    <!-- content -->
    <div class="content">
        <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
    </div>

</div>